import axios from 'axios'

const validateAuthApi = axios.create({
  baseURL: process.env.API_VALIDATE_URL
})

validateAuthApi.interceptors.request.use((config) => {
  const headers = { ...(config.headers || {}) }

  // Bearer
  let token = localStorage.getItem('idToken') || ''
  if (token && !/^Bearer\s/i.test(token)) token = `Bearer ${token}`
  if (token) headers['Authorization'] = token

  // API Key
  if (process.env.API_GATEWAY_API_KEY) {
    headers['Api-Key'] = process.env.API_GATEWAY_API_KEY
  }

  // 👉 headers que usa la policy del gateway (lee request.headers['session'] / ['member'])
  try {
    const raw = localStorage.getItem('authSession')
    if (raw) {
      const { id, member } = JSON.parse(raw)
      if (id) headers['session'] = id
      if (member) headers['member'] = member
    }
  } catch { /* noop */ }

  // Content-Type por si no viene
  if (!headers['Content-Type'] && !(config.data instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }

  config.headers = headers
  return config
})

export default validateAuthApi
